import { QuickActionCard } from '../../components/Dashboard/QuickActionCards';
import {
  Brain, Cog,
  Compass,
  Eye,
  FileText,
  Lightbulb, UserRoundCheck,
  Users, Wrench
} from "lucide-react";
import { AssessmentCard } from "../../components/Dashboard/AssessmentCard";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { RiasecLastTestResponse } from "../../typings/riasec";
import { riasecService } from "../../services/riasec.service";
import { vakService } from "../../services/vak.service";
import { pomService } from "../../services/pom.service";
import { powerSkillService } from "../../services/powerskill.service";
import { competencyService } from "../../services/competency.service";
import { VakLastTestResponse } from "../../typings/vak";
import { PomLastTestResponse } from "../../typings/pom";
import { PowerSkillLastTestResponse } from "../../typings/powerskill";
import { CompetencyTestType } from "../../typings/competency-test";
import { COMPETENCY_KART, COMPETENCY_TDNA, COMPETENCY_TKA } from "../../utils/competency";

const NewDashboard = () => {
  const [lastTestIDE, setLastTestIDE] = useState<RiasecLastTestResponse | null>(null);
  const [countUserIDE, setCountUserIDE] = useState<number | null>(
    null
  );
  const [lastTestSLP, setLastTestSLP] = useState<VakLastTestResponse | null>(null);
  const [countUserSLP, setCountUserSLP] = useState<number | null>(null);
  const [lastTestPOM, setLastTestPOM] = useState<PomLastTestResponse | null>(null);
  const [countUserPOM, setCountUserPOM] = useState<number | null>(null);
  const [lastTestPowerSkill, setLastTestPowerSkill] = useState<PowerSkillLastTestResponse | null>(null);
  const [countUserPowerSkill, setCountUserPowerSkill] =
    useState<number | null>(null);
  const [lastKART, setLastKART] = useState<CompetencyTestType[]>([]);
  const [lastTDNA, setLastTDNA] = useState<CompetencyTestType[]>([]);
  const [lastTKA, setLastTKA] = useState<CompetencyTestType[]>([]);

  const typeInterpretations: Record<string, string> = {
    ISTJ: 'Teliti, terstruktur, bertanggung jawab',
    ISFJ: 'Peduli, stabil, loyal',
    INFJ: 'Visioner, empatik, idealis',
    INTJ: 'Strategis, analitis, mandiri',
    ISTP: 'Praktis, logis, problem-solver',
    ISFP: 'Fleksibel, artistik, tenang',
    INFP: 'Reflektif, kreatif, penuh nilai',
    INTP: 'Analitis, konseptual, penasaran',
    ESTP: 'Aksi cepat, adaptif, energik',
    ESFP: 'Spontan, ceria, sosial',
    ENFP: 'Inspiratif, kreatif, energik',
    ENTP: 'Debater, inovatif, strategis',
    ESTJ: 'Eksekutor, efisien, terorganisir',
    ESFJ: 'Supportif, komunikatif, kooperatif',
    ENFJ: 'Pemimpin empatik, inspiratif',
    ENTJ: 'Visioner, tegas, pemimpin alami',
  };

  const getPomResultText = () => {
    if (!lastTestPOM?.data?.test?.ei_result) return "";
    const test = lastTestPOM.data.test;
    const mbtiType = `${test.ei_result}${test.sn_result}${test.tf_result}${test.jp_result}`;
    const interpretation = typeInterpretations[mbtiType];
    if (!interpretation) return "Test Selesai";
    return `Tipe Karakter: ${interpretation}`;
  };

  const loadLastIDE = async () => {
    try {
      const response = await riasecService.getLastTest(true);
      if(response?.status) {
        setLastTestIDE(response as RiasecLastTestResponse);
        setCountUserIDE(
          (response?.data &&
            (response as RiasecLastTestResponse)?.data?.test?.countUser) ||
            null
        );
      }else{
        setCountUserIDE((response as any)?.data?.countUser || null);
      }
    } catch (error) {
      console.error("Error loading last test:", error);
    }
  };
  const loadLastSLP = async () => {
    try {
      const response = await vakService.getLastTest(true);
      if(response?.status){
        setLastTestSLP(response as VakLastTestResponse);
        setCountUserSLP(response?.data && (response as VakLastTestResponse)?.data?.test?.countUser || null);
      }else{
        setCountUserSLP((response as any)?.data?.countUser || null);
      }
    } catch (error) {
      console.error("Error loading last test:", error);
    }
  };
  const loadLastPOM = async () => {
    try {
      const response = await pomService.getLastTest(true);
      if(response?.status){
        setLastTestPOM(response as PomLastTestResponse);
        setCountUserPOM(
          (response?.data &&
            (response as PomLastTestResponse)?.data?.test?.countUser) ||
            null
        );
      }else{
        setCountUserPOM((response as any)?.data?.countUser || null);
      }

    } catch (error) {
      console.error("Error loading last test:", error);
    }
  };
  const loadLastPowerSkill = async () => {
    try {
      const response = await powerSkillService.getLastTest(true);
      if(response?.status){
        setLastTestPowerSkill(response as PowerSkillLastTestResponse);
        setCountUserPowerSkill(response?.data && (response as PowerSkillLastTestResponse)?.data?.test?.countUser || null);
      }else{
        setCountUserPowerSkill((response as any)?.data?.countUser || null);
      }
    } catch (error) {
      console.error("Error loading last test:", error);
    }
  };

  const loadCompetency = async (code: string) => {
    try {
      const response = await competencyService.getMy(code);
      switch (code) {
        case COMPETENCY_TDNA:
          setLastTDNA(response?.data);
          break;
        case COMPETENCY_KART:
          setLastKART(response?.data);
          break;
        case COMPETENCY_TKA:
          setLastTKA(response?.data);
          break;
      }
    } catch (error) {
      console.error("Error loading last test:", error);
    }
  };

  useEffect(() => {
    loadLastIDE()
    loadLastSLP();
    loadLastPOM();
    loadLastPowerSkill();
    loadCompetency(COMPETENCY_KART);
    loadCompetency(COMPETENCY_TDNA);
    loadCompetency(COMPETENCY_TKA);
  },[])
  const history = useHistory();
  return (
    <>
      <section
        className="space-y-3 animate-slide-up"
        style={{
          animationDelay: "0.1s",
        }}
      >
        <h2 className="text-lg font-bold px-1">Aksi Cepat</h2>
        <QuickActionCard
          icon={Brain}
          title="Mulai Tes Minat & Potensi"
          description="Temukan jalur karir yang cocok untukmu"
          gradient="gradient-primary"
          onClick={() => {
            const targetElement = document.querySelector("#assessments");
            // Scroll the element into view with a smooth animation
            if (targetElement) {
              const targetPosition = (targetElement as any)?.offsetTop - 141;
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            }
          }}
        />
        <QuickActionCard
          icon={FileText}
          title="Bangun CV ATS"
          description="Buat CV profesional yang lolos screening"
          gradient="gradient-accent"
          onClick={() => {
            history.push("/cv-builder");
          }}
        />
      </section>
      <section
        className="space-y-4 animate-slide-up"
        id="assessments"
        style={{
          animationDelay: "0.3s",
        }}
      >
        <h2 className="text-lg font-bold px-1">Tes Minat dan Potensi</h2>
        <div className="grid gap-3">
          <AssessmentCard
            title="Interest Domain Explorer"
            status={lastTestIDE ? "completed" : "not-started"}
            icon={<Compass className="h-6 w-6" />}
            label={"SMP/MTs"}
            count={countUserIDE || null}
            result={
              lastTestIDE?.data?.test?.ai_generated
                ? `Rekomendasi: ${lastTestIDE?.data?.test?.ai_jalur} - ${lastTestIDE?.data?.test?.ai_jurusan}`
                : lastTestIDE
                ? "Test Selesai"
                : ""
            }
            onViewResult={() => history.push("/riasec")}
            onStart={() => history.push("/riasec")}
          />
          <AssessmentCard
            title="Kelase PersonaDNA"
            status={lastTestPOM ? "completed" : "not-started"}
            icon={<Users className="h-6 w-6" />}
            label={"UMUM"}
            count={countUserPOM || null}
            result={getPomResultText()}
            onViewResult={() => history.push("/pom")}
            onStart={() => history.push("/pom")}
          />
          <AssessmentCard
            title="Kelase LearningDNA"
            status={lastTestSLP ? "completed" : "not-started"}
            icon={<Eye className="h-6 w-6" />}
            label={"UMUM"}
            count={countUserSLP || null}
            result={
              lastTestSLP?.data?.test?.ai_generated
                ? `Gaya Belajar: ${lastTestSLP?.data?.test?.ai_type}`
                : lastTestSLP
                ? "Test Selesai"
                : ""
            }
            onViewResult={() => history.push("/vak")}
            onStart={() => history.push("/vak")}
          />
          <AssessmentCard
            title="Kelase ThinkingDNA"
            completeLabel="Sudah Dikerjakan"
            status={lastTDNA?.length > 0 ? "completed" : "not-started"}
            listComplete={lastTDNA}
            icon={<Lightbulb className="h-6 w-6" />}
            onStart={() => history.push("/competency/cat/" + COMPETENCY_TDNA)}
          />
          <AssessmentCard
            title="Kelase ART"
            completeLabel="Sudah Dikerjakan"
            status={lastKART?.length > 0 ? "completed" : "not-started"}
            icon={<Wrench className="h-6 w-6" />}
            listComplete={lastKART}
            onStart={() => history.push("/competency/cat/" + COMPETENCY_KART)}
          />
          <AssessmentCard
            title="Kelase PowerSkills"
            status={lastTestPowerSkill ? "completed" : "not-started"}
            icon={<Cog className="h-6 w-6" />}
            label={"UMUM"}
            count={countUserPowerSkill || null}
            result={
              lastTestPowerSkill?.data?.test?.result_category
                ? `Capaian: ${lastTestPowerSkill.data.test.result_category}`
                : ""
            }
            onViewResult={() => history.push("/powerskill")}
            onStart={() => history.push("/powerskill")}
          />
          <AssessmentCard
            title="Try Out Tes Kemampuan Akademik 2026"
            completeLabel="Sudah Dikerjakan"
            status={lastTKA?.length > 0 ? "completed" : "not-started"}
            icon={<UserRoundCheck className="h-6 w-6" />}
            listComplete={lastTKA}
            onStart={() => history.push("/competency/cat/" + COMPETENCY_TKA)}
          />
        </div>
      </section>
    </>
  );
}
export default NewDashboard